import { useContext } from 'react';
import AdminContext from '../contexts/AdminContext';

/**
 * Hook to access admin status and configuration
 * Must be used within AdminProvider
 */
export const useAdmin = () => {
  const context = useContext(AdminContext);

  if (!context) {
    throw new Error('useAdmin must be used within AdminProvider');
  }

  return context;
};
